import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PlanStep } from '../../../services/PlanStep';
import { StepComponent } from '../../step.component';
import { PlanCoordinate } from '../../../services/plan-coordinate';
import { PlanStepPage } from '../../../services/PlanStepPage';
import {ResourceService} from '../../../services/resource.service';

@Component({
  selector: 'app-develop-strategy-map',
  templateUrl: './develop-strategy-map.component.html',
  styleUrls: ['./develop-strategy-map.component.scss']
})
export class DevelopStrategyMapComponent extends StepComponent<void> implements OnInit {

  @Output() planCoordinateChange = new EventEmitter<PlanCoordinate>();

  constructor(_resourceService: ResourceService) {
    super(PlanCoordinate.stepBy(PlanStep.DEVELOP_STRATEGY_MAP), _resourceService);
  }

  ngOnInit() { }

  onPlanCoordinateChangeStrategyMap() {
    this.planCoordinateChange.emit(PlanCoordinate.stepPageBy(PlanStepPage.StrategyMap));
  }

}
